// removed by extract-text-webpack-plugin
module.exports = {"my-modal-single":"_2YYLKNyUa9kLD61ZDJ_dD_","my-modal":"_38JiaK0h6pQTsFtVB1e8mq","title":"_12grbyCBfv331qJdl6x62s","header":"kQRgk6HouwbTep3yneomU","content":"BQn0QYB0CKR4YKzm5rLwa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BaseModal/index.less
// module id = 359
// module chunks = 0